import * as React from 'react';
import Inspection from '../Inspection';
import { Stack } from '@fluentui/react';
import { Inspections, IInspectionModeConfig } from '@piceasoft/core';
import { noop } from '../../../../../../core/helpers/common';
import { strings } from '../../../../../../localization/strings';
import { IEraseConfig, IInspectionModeConfigUI } from '@piceasoft/core';
import { ErasesState } from './preview/EraseState';

export type uploadFileType = { imgUrl: string, loadProgress: number, data: File, label?: string }

type TProps = {
    config?: IEraseConfig
}

export const EraseStatePreview: React.FC<TProps> = (props) => {
    if (props.config === undefined) return null;

    return (
        <Stack grow tokens={{ padding: "32px 32px 32px 32px" }}>
            <Inspection
                inspection={Inspections.Erase}
                icon={props.config.ui?.icon ?? "EraseTool"}
                title={props.config.ui?.title ?? strings.CONSTRUCTOR.INSPECTIONS.ERASE.TITLE}
                allowRestart={props.config.allowRestart}
                onStart={noop}
                onRestart={noop}
                dependency={props.config.dependency}
                skips={props.config.skip}
                autoRun={props.config.autoRun}
                executeButtonText={props.config.ui?.executeButtonText}
                repeatButtonText={props.config.ui?.restartButtonText}
            >
                <Stack verticalFill tokens={{ childrenGap: 16 }}>
                    <ErasesState config={props.config.config as IInspectionModeConfig<IInspectionModeConfigUI>}
                    icon={props.config.ui?.icon} />
                </Stack>
            </Inspection>
        </Stack>
    );
}